import { Component, OnInit } from "@angular/core";
import { Client } from "src/app/services/API/client";
import { NotificationCountService } from "src/app/services/notificationCountService";
import { SessionService } from "src/app/services/session.service";
import { toastrService } from "src/app/services/ux/toastr.service";

@Component({
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"]
})
export class NotificationComponent implements OnInit {
  notifications: any[];
  loading = true;

  constructor(
    private api: Client,
    public toastr: toastrService,
    private notifService: NotificationCountService,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.getNotifications();
  }

  // get all notifications from api
  getNotifications() {
    this.loading = true;
    if (this.session.isLoggedIn()) {
      this.api
        .get("api/notifications")
        .then((res: any[]) => {
          this.notifications = res;

          this.markNotifSeen();
          this.sendNotifCountToNav();

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    }
  }

  // make all notificaitons seen
  markNotifSeen() {
    if (this.session.isLoggedIn()) {
      // get not seen notifications
      const notSeenNotif = this.notifications.filter(
        (notif) => notif.IsSeen === false
      );

      for (let i = 0; i < notSeenNotif.length; i++) {
        // nese nje notifikim eshte notSeen beji te gjithe seen
        if (notSeenNotif[i].IsSeen === false) {
          this.api.post("/api/notifications").catch((err) => {
            this.toastr.error(err);
          });
          break;
        }
      }
    }
  }

  // ndrysho count te notifikimeve ne 0
  sendNotifCountToNav() {
    this.notifService.updateCount(0);
  }
}
